module.exports = function(app) {
    app.directive('wellnessHealthyLinks', function() {

        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'wellness.appTemplate.html/chmhom/directives/wellnessHealthyLinks',

            // scope: {},
            controller: ['$scope',
                function($scope) {

                    $scope.showDownloadIcon = true;
                    $scope.noIconClass = "";
                }
            ]
        };
    });
}